module.exports = __webpack_public_path__ + "img/google_sheet.8c1b775d.png";